import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-foreground-600">影视圈前沿资讯与七七影院更新公告</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div
              key={item.id}
              className="flex gap-4 pb-5 mb-5 border-b border-background-200/60 last:border-b-0 last:pb-0 last:mb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0 pt-0.5">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 flex-shrink-0"></div>
                {idx < updatesData.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">{item.category}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 leading-snug">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}